import cx from "classnames";
import styles from "./NavHamburgerButton.module.scss";

interface Props {
  navIsExpanded: boolean;
  closeNav: () => void;
  openNav: () => void;
  hamburgerButtonRef: React.MutableRefObject<HTMLButtonElement>;
}

const NavHamburgerButton = ({
  navIsExpanded,
  closeNav,
  openNav,
  hamburgerButtonRef,
}: Props) => {
  return (
    <button
      className={styles.root}
      onClick={() => (navIsExpanded ? closeNav() : openNav())}
      aria-expanded={navIsExpanded}
      aria-controls="expanded-nav"
      aria-label={navIsExpanded ? "Close Main Menu" : "Open Main Menu"}
      data-action={navIsExpanded ? "Close Menu" : "Open Menu"}
      ref={hamburgerButtonRef}
    >
      <div className={cx(styles.burger, navIsExpanded && styles.isExpanded)}>
        <div className={styles.box}>
          <div className={styles.inner} />
        </div>
      </div>
    </button>
  );
};

export default NavHamburgerButton;
